<template>
  <div>
    <div>
      <p v-if="orderBy === 'ASC'" class="text-muted">Exibe renovações realizadas há mais de 1 ano.</p>
      <p v-else class="text-muted">Exibe renovações realizadas nos últimos 365 dias.</p>
    </div>
    <Tables
      ref="tableGrid"
      :columns="['Nome', 'CPF/CNPJ', 'Última Renovação', 'Telefone', 'Oportunidades']"
      :showTipFooter="false"
      :showReload="true"
      @Load="onLoadContacts"
      @Reload="reload"
    >
      <tr v-for="obj in objList" :key="obj.id">
        <TableColumn :IsText="true" :status="1" :value="obj.nome ? obj.nome : ''"
                      @Edit="() => openAssociatePage(obj.idAssociado, obj.idAssociado)"/>
        <TableColumn :IsText="true" :status="1" :value="obj.document ? obj.document : ''"
                      @Edit="() => openAssociatePage(obj.idAssociado, obj.idAssociado)"/>
        <TableColumn :IsText="true" :status="1" :value="obj.ultimaRenovacao ? moment.tz(obj.ultimaRenovacao, 'America/Sao_Paulo').format('DD/MM/YYYY').toString() : 'Não realizado'"
                      @Edit="() => openAssociatePage(obj.idAssociado, obj.idAssociado)"/>
        <TableColumn :IsText="true" :status="1" :value="obj.telefone ? obj.telefone : ''"
                     @Edit="() => openAssociatePage(obj.idAssociado, obj.idAssociado)"/>
        <td class="row justify-content-around">
          <div style="display: flex; justify-content: center; align-items: center;">
            <i
              class="fa fa-address-card cursor-pointer mt-1"
              style="color: black; font-size: 1.1rem"
              :title="'Oportunidades'"
              @click.stop="openOportunityModal(obj)"
            ></i>
          </div>
        </td>
      </tr>
    </Tables>
    <OportunityModal ref="OportunityModal" v-if="selectedObj" />
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import PersonRepository from '@/shared/http/repositories/configurations/person.js'
import OportunityModal from '@/views/private/StartPage/modal/OportunityModal.vue'

import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'LastRenovation',
  mixins: [ActionsForm],
  components: {
    OportunityModal
  },
  data () {
    return {
      selectedObj: null
    }
  },
  props: {
    orderBy: {
      type: String,
      default: 'ASC'
    }
  },
  methods: {
    async onLoad () {
      await this.onLoadContacts()
    },
    async reload () {
      loading.push()
      await this.onLoadContacts()
      loading.pop()
    },
    async onLoadContacts () {
      const response = await PersonRepository.GetAllLastRenovation(this.orderBy, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
      this.onResultGrid(response)
    },
    openAssociatePage (associateId) {
      this.$router.replace({
        name: 'AssociatePage',
        params: {
          associateId: associateId,
          backUrl: 'Associate'
        }
      })
    },
    openOportunityModal (obj) {
      this.selectedObj = obj
      this.$nextTick(() => {
        this.$refs.OportunityModal.showModal(obj)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/StartPage/LastRenovation.vue